var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "wrap",
    class: {
      show: _vm.showWrap
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('main-pc', {
    staticClass: "pc",
    attrs: {
      "showContent": _vm.showContent,
      "success": _vm.success,
      "close": _vm.closeHandle,
      "logout": _vm.logout,
      "thirdHost": _vm.thirdHost,
      "oldThirdHost": _vm.oldThirdHost,
      "clientId": _vm.clientId
    }
  }), _vm._v(" "), _c('main-m', {
    staticClass: "m",
    attrs: {
      "showContent": _vm.showContent,
      "success": _vm.success,
      "close": _vm.closeHandle,
      "logout": _vm.logout,
      "thirdHost": _vm.thirdHost,
      "oldThirdHost": _vm.oldThirdHost,
      "clientId": _vm.clientId
    }
  }), _vm._v(" "), _c('loginConfirm')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };